module.exports = __webpack_public_path__ + "assets/no-image-available.5deb5512e9d3f4f96d51a9ee68980dcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/no-image-available.jpg
// module id = 564
// module chunks = 0